import {UIController} from "../UIController";
import {SVGComponent} from "@webfruits/toolbox/dist/components/svg/SVGComponent";
import {CoreAssets} from "../../core/CoreAssets";
import {ShadowEffects} from "../../styles/ShadowEffects";

/******************************************************************
 * NewsletterModalController
 *
 * @author matthias.schulz@jash.de
 *****************************************************************/

export class NewsletterModalController extends UIController {

    /******************************************************************
     * Properties
     *****************************************************************/

    private readonly _dialog: HTMLDialogElement
    private readonly _closeButton: SVGComponent;

    /******************************************************************
     * Constructor
     *****************************************************************/

    constructor(rootElement: HTMLElement) {
        super(rootElement);
        this._dialog = rootElement as HTMLDialogElement;
        this._closeButton = new SVGComponent(CoreAssets.CLOSE_BUTTON);
        this._closeButton.view.className = "kkt-newsletter-signup-modal-close";
        this._dialog.appendChild(this._closeButton.view);
        this.initListeners()
    }

    /* ----------------------------------------------------------------
 	 *
 	 * --------------------------------------------------------------*/

    public async updateStyles() {
        this._closeButton.applyStyle({
            boxShadow: ShadowEffects.META_BUTTON_SHADOW,
        })
    }

    /******************************************************************
     * Private Methodes
     *****************************************************************/

    private initListeners(): void {
        this._closeButton?.view.addEventListener("click", () => {
            this._dialog.close();
        });
        this._dialog.addEventListener("click", (event: MouseEvent) => {
            if (event.target === this._dialog) {
                this._dialog.close();
            }
        });
    }
}
